(ns kyber.lib.pdftron.styles
  (:require [goog.object :as gobj]))

(defn- update-tool-styles
  [options {:keys [doc-viewer] :as apis} tool-name update-fn]
  (-> doc-viewer
      (js-invoke "getTool" tool-name)
      (js-invoke "setStyles" (partial update-fn options apis))))

(defn ->admin-border-color
  ([Color]
   (->admin-border-color Color 1))
  ([Color opacity]
   (new Color 83 194 190 opacity)))

(defn ->admin-color
  ([Color]
   (->admin-color Color 1))
  ([Color opacity]
   (new Color 202 237 236 opacity)))

(defn ->learner-color
  ([Color]
   (->learner-color Color 1))
  ([Color opacity]
   (new Color 245 236 205 opacity)))

(defn set-tool-styles! [options apis]
  ;; NOTE: Rects are an admin only feature for now
  (update-tool-styles
   options apis "AnnotationCreateRectangle"
   (fn [_ {:keys [annotations]} _current-styles]
     (let [Color (gobj/get annotations "Color")]
       #js {:StrokeColor (->admin-border-color Color)
            :FillColor (->admin-color Color 0)
            :StrokeThickness 2
            :Opacity 1})))

  (update-tool-styles
   options apis "AnnotationCreateSticky"
   (fn [{:keys [is-learner]} {:keys [annotations]} _]
     (let [Color (gobj/get annotations "Color")]
       #js {:StrokeColor (if is-learner
                           (->learner-color Color)
                           (->admin-color Color))
            :FillColor (if is-learner
                         (->learner-color Color)
                         (->admin-color Color))
            :Opacity 0.9
            :StrokeThickness 2
            :TextColor (new Color 228 66 52 1)
            :FontSixe "9pt"})))

  (update-tool-styles
   options apis "AnnotationCreateTextHighlight"
   (fn [{:keys [is-learner]} {:keys [annotations]} _]
     (let [Color (gobj/get annotations "Color")]
       #js {:StrokeColor (if is-learner
                           (->learner-color Color)
                           (->admin-color Color))
            :FillColor (if is-learner
                         (->learner-color Color)
                         (->admin-color Color))}))))
